<template>
    <div class="upload-component">
    <vue-dropzone
        :ref="'fileDropzone'+uniqueCode"
        :id="'file-dropzone-'+uniqueCode"
        :options="getOptions"
        :useCustomSlot="true"
        class="my-4"
        @vdropzone-error="uploadError"
        @vdropzone-success="fileAdded"
        @vdropzone-removed-file="fileRemoved"
    >
        <div class="dropzone-custom-content">
            <h3 class="dropzone-custom-title">
                {{ $t(boxText)}}
            </h3>
            <p class="subtitle is-size-7 has-text-grey">
                {{ $t(boxTextDesc) }}
            </p>
        </div>
    </vue-dropzone>

    <ul :class="'preview-file-'+uniqueCode" class="dropzone-previews"></ul>

        <!-- preview template -->
        <div
            class="preview"
            style="display: none"
            :ref="'preview-template-'+uniqueCode"
            :id="'preview-template-'+uniqueCode"
        >
            <li>
                <div>
                    <div class="dz-preview dz-file-preview">
                        <div class="dz-progress">
                            <span class="dz-upload" data-dz-uploadprogress></span>
                        </div>
                        <div class="columns is-mobile is-vcentered">
                            <div class="column is-10 px-5 py-5">
                                <div class="dz-filename is-size-6">
                                    <span data-dz-name=""></span>
                                </div>
                                <div class="dz-size is-size-7">
                                    <span data-dz-size=""></span>
                                </div>
                            </div>
                            <div class="column is-2 has-text-right pr-5">
                                <a class="dz-remove" data-dz-remove="">
                                    <span class="icon has-text-danger mt-1">
                                        <i class="mdi mdi-24px mdi-trash-can"></i> 
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';

//import from 'search-osm-batch'
export default {
    name: 'AppUploadFile',
    components: {
        vueDropzone: vue2Dropzone,
        draggable,
    },
    props: {
        boxText: {
            type: String,
            default: '',
        },
        boxTextDesc: {
            type: String,
            default: '',
        },
        content: {
            type: Array,
            default() {
                return [];
            },
        },
        type: {
            type: String,
            default: 'image'
        },
        lang: {
            type: String,
            default: 'es'
        },
    },
    data() {
        return {
            uniqueCode: '000',

            

            imagesDropzoneOptions: {
                url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                thumbnailWidth: 150,
                maxFilesize: 4,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                previewsContainer: '.preview-file-' + this.uniqueCode,
                parallelUploads: 1,
                //disablePreviews: true,
                acceptedFiles: 'image/gif,image/jpeg,image/png',
                dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                dictResponseError: this.$t('dropzone.dict_response_error'),
                dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                dictCancelUploadConfirmation: this.$t(
                    'dropzone.dict_cancel_upload_confirmation'
                ),
                dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                dictMaxFilesExceeded: this.$t(
                    'dropzone.dict_max_files_exceeded'
                ),
            },
            
        }
    },
    created() {
        this.uniqueCode = this.generateCode();
    },
    mounted() {
        this.$refs['fileDropzone'+this.uniqueCode].setOption(
            'previewTemplate',
            document.getElementById('preview-template-' + this.uniqueCode).innerHTML
        );
        // console.log(this.content)
        if (this.content) {
            this.content.forEach((fileData) => {
                // console.log("fileData", fileData)
                if (fileData) {
                    let file = {
                        size: fileData.size,
                        name: fileData.name,
                        type: fileData.mimeType,
                        draggable: true,
                    };
                    let url = fileData.url;
                    this.$refs['fileDropzone' + this.uniqueCode].manuallyAddFile(file, url);
                }
            });      
        }
    },
    computed: {
        getOptions() {
            switch (this.type) {
                case "audio":
                //return this.audioDropzoneOptions;
                    return {
                        url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                        thumbnailWidth: 150,
                        maxFilesize: 4,
                        maxFiles: 1,
                        //headers: { 'My-Awesome-Header': 'header value' },
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`,
                        },
                        previewsContainer: `.preview-file-${this.uniqueCode}`,
                        acceptedFiles: 'audio/mpeg',

                        dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                        dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                        dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                        dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                        dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                        dictResponseError: this.$t('dropzone.dict_response_error'),
                        dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                        dictCancelUploadConfirmation: this.$t(
                            'dropzone.dict_cancel_upload_confirmation'
                        ),
                        dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                        dictMaxFilesExceeded: this.$t(
                            'dropzone.dict_max_files_exceeded'
                        ),
                    }
                case "files":
                //return this.filesDropzoneOptions;
                    return {
                        url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                        thumbnailWidth: 150,
                        maxFilesize: 4,
                        //headers: { 'My-Awesome-Header': 'header value' },
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`,
                        },
                        previewsContainer: `.preview-file-${this.uniqueCode}`,
                        acceptedFiles:
                            'application/pdf,application/vnd.ms-powerpoint,application/zip,application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.spreadsheet,application/vnd.oasis.opendocument.presentation,application/epub+zip,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

                        dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                        dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                        dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                        dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                        dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                        dictResponseError: this.$t('dropzone.dict_response_error'),
                        dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                        dictCancelUploadConfirmation: this.$t(
                            'dropzone.dict_cancel_upload_confirmation'
                        ),
                        dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                        dictMaxFilesExceeded: this.$t(
                            'dropzone.dict_max_files_exceeded'
                        ),
                    }
                case "images":
                    return this.imagesDropzoneOptions;
            }
        },
    },
    methods: {
        generateCode(longitud = 8) {
            const caracters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let resultat = '';
            for (let i = 0; i < longitud; i++) {
                const indexAleatori = Math.floor(Math.random() * caracters.length);
                resultat += caracters[indexAleatori];
            }
            return resultat;
        },
        uploadError(file, message, xhr) {
            this.$refs['fileDropzone'+this.uniqueCode].removeFile(file);
            const errorMessage = '<i>' + file.name + '</i></br> ' + message;
            this.$emit('addError', { 'type': this.type, 'message': errorMessage });
        },
        fileAdded(file, response) {
            this.$emit('fileAdded', {'type':this.type,'lang':this.lang,response}); 
        },
        fileRemoved(file, error, xhr) {
            this.$emit('fileRemoved', {'type':this.type,'lang':this.lang,file}); 
        },
    },
    
}
</script>
<style lang="css" scoped>
    .upload-component .dropzone-previews {
    padding: 0;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    list-style-type: none;
}
.upload-component .dropzone-previews li{
    border: 1px solid #0074d9;
    border-radius: 4px;
}
</style>